import React, { useContext, useEffect } from 'react';
import Tab from '../../components/elements/Tab';
import { useLocation, useNavigate } from 'react-router-dom';
import ProcessedCustomer from './fragments/ProcessedCustomer';
import { Stack } from '@mantine/core';
import { AppContext } from '../../contexts';
import OnProcessCustomer from './fragments/OnProcessCustomer';
import { useDispatch, useSelector } from 'react-redux';
import { clearRedux, fetchSummaryUnblockCustomer } from './actions';

const CustomerSubmissionUnblock = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { setBreadcrumbs } = useContext(AppContext);
  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get('tab') || 'on_process';

  const { dataSummary } = useSelector(({ customerSubmissionUnblock }) => customerSubmissionUnblock);

  const tabList = [
    { label: 'Perlu Diproses',
      value: 'on_process',
      info: dataSummary?.needVerification,
    },
    { label: 'Selesai Diproses', value: 'done' },
  ];

  const handleChangeTab = (val) => {
    dispatch(clearRedux('dataCustomerUnblock'));
    dispatch(clearRedux('messageCustomerUnblock'));
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('tab', val);
    navigate('?' + newSearchParams.toString());
  };

  useEffect(() => {
    setBreadcrumbs(['Pengajuan Buka Blokir']);
    dispatch(fetchSummaryUnblockCustomer());
  }, []);
  return (
    <Stack gap={12}>
      <Tab
        data={tabList}
        defaultValue={currentTab}
        onChange={handleChangeTab}
      />
      {currentTab === 'on_process' && <>
        <OnProcessCustomer dataVerif={dataSummary} dispatch={dispatch}/>
      </>}
      {currentTab === 'done' &&<>
        <ProcessedCustomer dispatch={dispatch} />
      </>}
    </Stack>
  );
};

export default CustomerSubmissionUnblock;
